export const palette = {
  primary: { main: '#e2b007' },
  secondary: { main: '#b2102f' },
  danger: { main: '#b2102f'}
};